// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__37yMz","containerItemsCenter":"Skeleton_containerItemsCenter__rT-O1"};